<div class="outerwrap" fxLayout="column" fxLayoutAlign="start stretch">
    <h1 mat-dialog-title>{{title}}</h1>
    <div class="scroll" fxFlex fxLayout="column" fxLayoutAlign="start stretch">
        <div *ngIf="message" [innerHTML]="message | safeHTML"></div>
        <div>
            <div fxLayout="row" fxLayoutAlign="start start" fxLayout.lt-md="column" fxLayoutAlign.lt-md="start stretch">
                <div fxFlex.gt-sm="40"> <!--  fxFlex.gt-sm="40" -->
                    <div><strong>Prefix: </strong>{{Course.Prefix}}</div>
                    <div><strong>Code: </strong>{{Course.Code}}</div>
                    <div><strong>Name: </strong>{{Course.Name}}</div>
                    <div><strong>Credits: </strong>{{Course.Credits}}</div>
                    <div><strong>HS Subject Area Equivalency: </strong>{{Course.GradReqName || 'N/A'}}</div>
                    <div><strong>HS Credits: </strong>
                        <span *ngIf="Course.HSCredit != null">{{Course.HSCredit | number:'1.1'}}</span>
                        <span *ngIf="Course.HSCredit == null">N/A</span>
                    </div>
                </div>
                <div fxFlex.gt-sm="40"> <!--  fxOffset.gt-sm="10" fxFlex.gt-sm="40" -->
                    <div fxLayout="row" fxLayoutAlign="start start" fxLayout.lt-md="column">
                        <div><strong>Prerequisite(s): </strong></div>
                        <div fxFlex>{{Course.Prerequisites}}</div>
                    </div>
                    <div *ngIf="Course.Corequisites" fxLayout="row" fxLayoutAlign="start start" fxLayout.lt-md="column">
                        <div><strong>Corequisite(s): </strong></div>
                        <div fxFlex>{{Course.Corequisites}}</div>
                    </div>
                </div>
            </div>
        </div>
        <div>
            <div style="margin-top:20px"><strong>Description:</strong></div>
            <div [innerHTML]="Course.Description | safeHTML"></div>
        </div>
    </div>
    <div class="actionbar" fxLayout="row" fxLayoutAlign="end center">
        <button mat-raised-button color="primary" (click)="OKHandler()">{{oktext}}</button>
    </div>
</div>



// WEBPACK FOOTER //
// ./src/services/dialogs/coursedescription/coursedescription.dialogcomponent.html